/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationExcerptData } from '../definitions';
import type GenericPlatform from '../../generic';

export default class GenericConversationExcerpt implements ConversationExcerptData {
  private platform: GenericPlatform;

  constructor(platform: GenericPlatform) {
    this.platform = platform;
  }

  title(excerptsEnabled: boolean) {
    let defaultPrefix = 'fin-ai-agent.knowledge.content-sources.conversation-excerpts';
    let prefix = excerptsEnabled ? `${defaultPrefix}.enabled` : defaultPrefix;
    return this.platform.intl.t(`${prefix}.default`);
  }

  get link() {
    return undefined;
  }
}
